<div class="button-container">
  @if (!excludePrimaryButton()) {
    <gc-button [size]="'full'" (clicked)="onClickPrimary()">
      {{ primaryButtonText | translate }}
    </gc-button>
  }
  @if (!excludeSecondaryButton()) {
    <gc-button
      [variant]="'secondary'"
      [size]="'full'"
      (clicked)="onClickSecondary()"
    >
      {{ secondaryButtonText | translate }}
    </gc-button>
  }
</div>
